import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpService } from "services/http.service";
import { ActionRequiredModel } from "services/models/action-required";
import { ServiceBase } from "services/servicebase";

export type ActionRequiredListItem = ActionRequiredModel & {
	movementType?: number | null;
};

@Injectable()
export class ActionRequiredService extends ServiceBase<ActionRequiredModel> {
	constructor(http: HttpService) {
		super("actionRequired", http, environment.apiUrl);
	}

	createEntity(input: any): ActionRequiredModel {
		return ActionRequiredModel.create(input);
	}

	getMyPendings(): Observable<ActionRequiredListItem[]> {
		return this.http.get(`${this.endpoint}/my/pendings?$orderBy=creationDate desc`, null, null, null, true).pipe(
			map((data: any) => data.body.map((item) => this._createListItem(item)))
		);
	}

	getMyFinisheds(): Observable<ActionRequiredModel[]> {
		return this.http.get(`${this.endpoint}/my/finished?$orderBy=creationDate desc`, null, null, null, true).pipe(
			map((data: any) => data.body.map(item => ActionRequiredModel.create(item)))
		);
	}

	getBySourceAndReferenceId(source: number, referenceId: string,): Observable<ActionRequiredModel> {
		return this.http.get(`${this.endpoint}/by-source-and-reference-id?source=${source}&referenceId=${referenceId}`, null, null, null, true).pipe(
			map((data: any) => ActionRequiredModel.create(data.body))
		);
	}

	getBySourceAndReferenceIdWithoutApprovalScopeCheck(source: number, referenceId: string,): Observable<ActionRequiredModel> {
		return this.http.get(`${this.endpoint}/by-source-and-reference-id-without-approval-scope-check?source=${source}&referenceId=${referenceId}`, null, null, null, true).pipe(
			map((data: any) => ActionRequiredModel.create(data.body))
		);
	}

	markActionRequiredForFinished(id: string) {
		return this.http.put(`${this.endpoint}/${id}/mark-as-finished`, {});
	}

	private _createListItem(input: any): ActionRequiredListItem {
		const model = ActionRequiredModel.create(input) as ActionRequiredListItem;
		model.movementType = input?.movementType ?? null;
		return model;
	}
}
